<template>
    <div>
        <div class="row">
            <div class="col s12 m12 l12 xl12 flow-text">
                <h1 class="grey-text brand-font no-buffer" v-html="title"></h1>
            </div>
        </div>

        <div class="divider"></div>

        <div v-if="imageAndVideo">
            <div class="row">
                <div class="col s12 m12 l12 xl12">

                    <div class="video-container z-depth-3">
                        <iframe :src="video"
                                frameborder="0"
                                enablejsapi=1
                                allowfullscreen></iframe>
                    </div>

                </div>
            </div>
            <div class="divider" style="margin: 3em 0px 1em 0px;"></div>
        </div>

        <div class="row">
            <div class="col s12 m12 l7 xl7">

                <div class="video-container z-depth-3" style="margin-top: 2em;" v-if="videoOnly">
                    <iframe :src="video"
                            frameborder="0"
                            enablejsapi=1
                            allowfullscreen></iframe>
                </div>

                <div class="card z-depth-3" v-if="image" :class="[imageAndVideo ? 'hide-on-med-and-down':'']">
                    <div class="card-image">
                        <img :src="sizedImage"/>
                        <span class="card-title brand-font brand-color hide-on-small-and-down" v-html="short"></span>
                    </div>
                    <div class="card-content hide-on-med-and-up">
                        <span class="brand-font brand-color" v-html="short"></span>
                    </div>
                </div>

            </div>

            <div class="col s12 m12 l5 xl5 flow-text grey-text">
                <h3 class="grey-text brand-font center" v-html="subtitle"></h3>
                <div class="brand-font" v-html="long"></div>
            </div>

        </div>

        <div class="row" v-if="nextPage">
            <div class="col s12 m12 l12 xl12 flow-text">
                <next :slug="nextPage.slug" :caption="nextPage.name"></next>
            </div>
        </div>

        <div class="row" v-if="freebie">
            <div class="col s12 m12 l12 xl12 flow-text">
                <email :freebie="freebie"></email>
            </div>
        </div>

        <div class="row" v-if="offer">
            <div class="col s12 m12 l12 xl12 flow-text">
                <purchase :offer="offer"></purchase>
            </div>
        </div>

        <div class="row" v-if="splitter">
            <div class="col s12 m12 l12 xl12 flow-text">
                <splitter :splitter="splitter"></splitter>
            </div>
        </div>


    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'
    import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
    import Purchase from './actions/Purchase'
    import Next from './actions/Next'
    import Email from './actions/Email'
    import splitter from './actions/Splitter'

    export default {
        components: {NprogressContainer, Purchase, Next, Email, splitter},
        props: {
            //route :param
            slug: {default: 'home'}
        },

        watch: {
            $route(to, from) {
                this.$nprogress.start();
                var slug = (typeof to.params.slug != 'undefined') ? to.params.slug : 'home';
                broadcast({event: 'lander', slug: slug})

                if(this.slug == 'sent' || this.slug == 'success'){
                    this.$confetti.start();
                    setTimeout(() => this.$confetti.stop(), 1000 *15);
                }
            }
        },

        computed: {

            sizedImage: function () {
                return this.image + '?w=750';
            },

            ...mapState({
                title: state => state.lander.title,
                subtitle: state => state.lander.subtitle,
                image: state => state.lander.image,
                short: state => state.lander.short,
                long: state => state.lander.long,

                video: (state) => {
                    if (typeof state.lander.video == 'string') {
                        return state.lander.video + '?rel=0&controls=0&showinfo=0'
                    }
                    return state.lander.video;
                },

                imageOnly: (state) => {
                    return (state.lander.image && !state.lander.video) ? true : false;
                },
                videoOnly: (state) => {
                    return (state.lander.video && !state.lander.image) ? true : false;
                },
                imageAndVideo: (state) => {
                    return (state.lander.image && state.lander.video) ? true : false;
                }
            }),

            ...mapGetters({
                offer: 'offer',
                freebie: 'freebie',
                goody: 'goody',
                interview: 'interview',
                nextPage: 'nextPage',
                splitter: 'splitter'
            }),

        },

        mounted: function () {
            this.$nprogress.start();
            broadcast({event: 'lander', slug: this.slug});
        }
    }
</script>